<template>
    <div class="student-login" :style="{background: loginImg?`url(${defaultBg}) no-repeat 100% 100%`:`url(${defaultBg}) no-repeat 100% 100%`}">
        <img v-if="globalObj.logo" class="logo-left" :src="globalObj.logo.image">
        <form class="content" id="myform" method="post" novalidate="novalidate">
            <div class="left-img" style="height: 100px;">
                <div class="top">
                    <div class="top-right" style="width: 100%;margin-left:0px">
                        <span style="font-size: 40px;">国 际 财 务 管 理 师 IFM 考 试 系 统</span>
                        <span style="font-weight: 600;">International Financial Manager (IFM) Examination System IFM Exam System</span>
                    </div>
                </div>
            </div>
            <div class="form-body">
                <div class="title">登录考试系统</div>
                <div class="form-group e-group">
                    <div class="sub-blo">
                        <img src="../assets/hms/username.png">
                        <span>|</span>
                    </div>
                    <input v-model="phone" class="input-large" type="text" autocomplete="off" placeholder="请输入姓名" name="data[username]">
                </div>
                <div class="form-group e-group">
                    <div class="sub-blo">
                        <img src="../assets/hms/new-icon.png" style="height: 22px;">
                        <span>|</span>
                    </div>
                    <input v-model="password" class="input-large" type="text" autocomplete="off" placeholder="请输入身份证号码" name="data[password]">
                    <!-- <div class="reset-btn" @click="reset">忘记密码</div> -->
                </div>
                <div class="login-btn" @click="next()">登 录</div>
            </div>
        </form>

        <!-- Modal -->
        <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
                <h3>请选择</h3>
                <div class="form-group">
                    <label>类别:</label>
                    <div v-for="category in categories" :key="category.id">
                        <input type="radio" :id="'cat-' + category.id" :value="category.id" v-model="selectedCategory">
                        <label :for="'cat-' + category.id">{{ category.name }}</label>
                    </div>
                </div>
                <div class="form-group">
                    <label>科目:</label>
                    <div v-for="subject in subjects" :key="subject.id">
                        <input type="radio" :id="'sub-' + subject.id" :value="subject.id" v-model="selectedSubject">
                        <label :for="'sub-' + subject.id">{{ subject.name }}</label>
                    </div>
                </div>
                <div class="modal-actions">
                    <button style="background-color: grey;" @click="showModal = false">取消</button>
                    <button @click="confirmLogin">确认</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            phone:'',
            password:'',
            defaultBg: require('../assets/loginBg.png'),
            showModal: false,
            categories: [],
            subjects: [],
            selectedCategory: '',
            selectedSubject: '',
        }
    },
    computed:mapState([
        'globalObj'
    ]),
    components:{
        
    },
    created() {
    },
    methods: {
       reset(){
           this.$router.push('/reset');
       },
       async next(){
            if(this.validateItem()){
                try {
                    const res = await this.$http.post('/api/user/examLoginCheck',{username:this.phone,id_number:this.password});
                    console.log(res,'res')
                    if(res.is_exist!==1){
                        this.$toast('姓名身份证不匹配');
                        return;
                    }
                    // Assuming res.data contains categories and subjects
                    this.categories = res.login_type_list || [];
                    this.subjects = res.login_subject_list || [];
                    if (this.categories.length > 0) {
                        this.selectedCategory = this.categories[0].value;
                    }
                    if (this.subjects.length > 0) {
                        this.selectedSubject = this.subjects[0].value;
                    }
                    this.showModal = true;
                } catch (error) {
                    this.$toast(error.message||'请求失败');
                }
            }
        },
        async confirmLogin() {
            if (!this.selectedCategory) {
                this.$toast('请选择类别');
                return;
            }
            if (!this.selectedSubject) {
                this.$toast('请选择科目');
                return;
            }
            try {
                const res = await this.$http.post('/api/user/login', {
                    username: this.phone,
                    id_number: this.password,
                    login_type: this.selectedCategory,
                    login_subject: this.selectedSubject,
                    grade: 3
                });
                if (Object.hasOwnProperty.call(res, 'userinfo')) {
                    localStorage.setItem('ifm_token', res.userinfo.token);
                    localStorage.setItem('ifm_userinfo', JSON.stringify(res.userinfo));
                    this.$store.commit('CHANGE_STATE', { userInfo: res.userinfo });
                    this.$toast('登录成功');
                    this.showModal = false;
                    const tem = setTimeout(() => {
                        this.$router.push('/myexams');
                        clearTimeout(tem);
                    }, 1500);
                }
            } catch (error) {
                this.$toast(error.message || '请求失败');
            }
        },
        validateItem(){
            const phone = this.phone;
            const pasword = this.password;
            // const myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if(phone===''){
                this.$toast('请输入姓名')
                return false;
            }else if(pasword === ''){
                this.$toast('请输入身份证号码')
                return false;
            }
            return true;
        }
    },
}
</script>
<style lang="scss" scoped>
.logo-left{
    position: absolute;
    z-index: 99;
    height: 55px;
    left: 40px;
    top: 30px;
}
.student-login{
    width: 100%;
    min-width: 1200px;
    height: 100vh;
    min-height: 600px;
    position: relative;
    background-size: 100% 100% !important;
}

.ext{
    position: relative;
    .ext-input{
        // width:80px;
    }
    .get-code{
        position: absolute;
        right: 135px;
        top: 20px;
        border-radius: 4px;
        padding: 6px 6px;
        background: #002c56;
        color: #fff;
        font-size: 13px;
    }
}
.control-label{
    font-family: Microsoft YaHei !important;
    font-weight: bold !important;
    color: #000000 !important;
}

.form-body{
    padding: 30px 36px 60px 36px;
    z-index: 999;
    background-color: #fff;
    height: 340px;
    box-sizing: border-box;
    .title{
        text-align: center;
        font-weight: bold;
        padding-bottom: 30px;
        font-size: 20px;
    }
    .e-group{
        width: 100% !important;
        margin-bottom: 35px;
    }
}
.input-large{
    padding-left: 45px !important;
    box-sizing: border-box;
    height: 43px;
}
.sub-blo{
    position: absolute;
    left:12px;
    top: 10px;
    img{
        width: 13.69px;
        height: 16.08px;
        margin-right: 8px;
        vertical-align: middle;
    }
    span{
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
    }
}
.login-btn{
    width: 100%;
    text-align: center;
    height: 48px;
    line-height: 48px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    background-color: #369bd4;
    cursor: pointer;
}
.my-btn{
    background: #002E67;
    padding: 5px 28px;
    border-radius: 3px;
    color: #fff;
    position: absolute;
    font-weight: bold;
    display: inline-block;
    bottom: -63px;
    left: 102px;
    cursor: pointer;
}
.reset-btn{
    color: #999999;
    text-align: right;
    font-size: 12px;
    font-weight: 600;
    font-family: "PingFang SC";
    position: absolute;
    bottom: -20px;
    right: 0px;
    cursor: pointer;
}
.login-title{
    text-align: center;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 80px;
}
.content{
    display: flex;
    align-items: center;
    width: 1030px;
    justify-content: space-between;
    margin: auto;
    height: 100%;
}
.left-img{
    width: 680px !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 400px;
    h3 {
        margin-top: 0;
    }
    .form-group {
        margin-bottom: 15px;
        label {
            font-weight: bold;
        }
        div {
            margin-top: 5px;
        }
    }
    .modal-actions {
        text-align: right;
        button {
            display: inline-block;
            height: 36px;
            line-height: 36px;
            padding: 0 20px;
            color: #ffffff;
            font-size: 14px;
            background-color: #369bd4;
            cursor: pointer;
            border: none;
            border-radius: 3px;
            margin-left: 10px;
            font-family: "PingFang SC";
            font-weight: 400;
        }
    }
}
</style>
